import React from 'react';

const TermsClubskp = () => (
  <div>
    <p>
      <strong>CLUBSKP PROGRAM - GENERAL TERMS</strong>
    </p>
    <p>
      <strong>
        PLEASE READ THESE TERMS OF USE CAREFULLY. BY PARTICIPATING IN THIS
        PROGRAM, YOU AGREE TO BE BOUND BY THESE TERMS. IF YOU DO NOT AGREE TO
        ALL OF THESE TERMS, (“TERMS”), AND THE SCHWARZKOPF PROFESSIONAL PRIVACY
        POLICY, YOU MAY NOT PARTICIPATE IN THIS PROGRAM.
      </strong>
    </p>
    <ol style={{ paddingLeft: '16px' }}>
      <li style={{ marginBottom: '16px' }}>
        <strong>PROGRAM OUTLINE AND ELIGIBILITY</strong>
        <p>
          The Schwarzkopf Professional (<strong>“SKP”</strong>) CLUBSKP program
          (<strong>“Program”</strong>) is open only to Schwarzkopf Professional
          Salons (<strong>“Salons”</strong>) located in the United States who
          purchase Schwarzkopf Professional products from an Authorized
          Schwarzkopf Professional distributor house. The Program is not open to
          individuals (whether a stylist or not), non-business consumers, or to
          any individual acting for personal, family or household, purposes.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <strong>EARNING POINTS</strong>
        <ol type="a" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              The Program allows participating Salons to earn points (<strong>“Points”</strong>)
              based on the purchases by the Salon of any Schwarzkopf
              Professional product. The number of Points earned by the Salon is
              based on the <strong>“Reward Level”</strong> assigned to that
              Salon. There are three Reward Levels – S, K or P. Reward Levels
              are based on the total monthly Schwarzkopf Professional purchases
              by the Salon with their designated authorized Schwarzkopf
              Professional Distributor House in the prior month. Your Reward
              Level may fluctuate from month to month depending on your total
              monthly Schwarzkopf Professional purchases in the prior month. The
              monthly purchase range associated with each Reward Level is set
              out on the Program Website at [www.myskp.com] (<strong>“Website”</strong>),
              and may be changed by Schwarzkopf Professional at any time in our
              sole and absolute discretion. Salons earn Points for each dollar
              spent by the Salon, in the United States, on any Schwarzkopf
              Professional product with their designated authorized Schwarzkopf
              Professional Distributor House. The rate at which Points are
              earned is determined by the Reward Level of the Salon, and is set
              out on the Website, and may be changed by Schwarzkopf Professional
              at any time in our sole and absolute discretion.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Points begin to accumulate only after your account has been
              approved by Schwarzkopf Professional’s designated CLUBSKP
              administrator and the Salon has made Schwarzkopf Professional
              purchases from their chosen Authorized Schwarzkopf Professional
              distributor house. You may earn Points only from Schwarzkopf
              Professional purchases from one (1) Authorized Schwarzkopf
              Professional distributor house. You must designate the Authorized
              Schwarzkopf Professional distributor house you wish to use to
              participate in the Program by contacting our CLUBSKP
              administrator.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Once Salon enrollment in the Program has been approved by the
              CLUBSKP administrator, the Salon will receive temporary login
              information. It the responsibility of the Salon to change /update
              their password.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              The participating Authorized Schwarzkopf Professional Distributor
              houses may be changed by Schwarzkopf Professional in its sole
              discretion.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              When you enroll in the Program or provide us with information, you
              agree: (i) that you will provide complete and accurate information
              about the Salon as requested; and (ii) to promptly update such
              information as it changes to ensure that it is kept accurate and
              complete. You are solely responsible for the accuracy of all
              information that you provide to Schwarzkopf Professional, and for
              all activity that takes place in your account. In the event that
              you do not provide or update such information, or Schwarzkopf
              Professional has reasonable grounds to suspect that you have not
              provided or updated such information, Schwarzkopf Professional
              shall have the right, in its sole and absolute discretion, to
              prevent you from participating in the Program. It is your sole and
              absolute responsibility to keep the username, password and other
              information associated with your account confidential and secure.
              In the event that your username, password and/or account are used
              without your consent or that you discover any other breach of
              security, you agree to promptly notify us. We are not responsible
              for your failure to comply with this clause, or for any delay in
              shutting down your account after you have reported a breach of
              security to us. You are solely responsible for any and all
              activities which occur under your account.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              All Program registrations are subject to verification at any time
              and for any reason. Schwarzkopf Professional reserves the right,
              in its sole and absolute discretion, to require proof of identity
              and/or eligibility (in a form acceptable to Schwarzkopf
              Professional – including, without limitation, government issued
              photo identification): (i) for the purposes of verifying a Salon’s
              eligibility to participate in the Program; and/or (ii) for any
              other reason Schwarzkopf Professional deems necessary, in its sole
              and absolute discretion, for the purposes of administering the
              Program in accordance with these Terms. Failure to provide such
              proof to the satisfaction of Schwarzkopf Professional in a timely
              manner may result in the cancellation of your account and in such
              a case any Points associated with it may be forfeited.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              It is the Salon’s responsibility to maintain /update their
              credentials within their CLUBSKP profile, to remain active and
              redeem. This includes, but, is not limited to updating the
              information you have provided if there is any change to address
              and/or contact information you have provided.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>Backdating of Points is not permissible.</p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Points expire on March 31st of every calendar year following the
              year in which they were earned, unless stipulated in writing any
              differently from Schwarzkopf Professional. Unused Points remaining
              following the termination date are forfeited.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              If a participating Salon: i) does not make any qualifying
              Schwarzkopf Professional product purchases within a twelve (12)
              month period, or ii) does not redeem any Points within a twelve
              (12) month period, then Schwarzkopf Professional reserves the
              right, in its sole discretion, and with or without notice to the
              Salon, to deem the Salon account inactive, and to terminate the
              account and declare any Points therein void.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <strong>REDEEMING POINTS</strong>
        <ol type="a" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>THRESHOLDS FOR REDEMPTION</p>
            <ul>
              <li>
                <p>
                  - Salons are limited to redeeming one color chart per brand,
                  per year.
                </p>
              </li>
              <li>
                <p>
                  - A minimum of 5,000 Points to a max of 90,000 Points must be
                  redeemed at any one given time.
                </p>
              </li>
            </ul>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Points may be redeemed for redemption items designated by
              Schwarzkopf Professional from time to time in our sole and
              absolute discretion. The current redemption items, and the amount
              of Points which must be redeemed for them are set out on the
              Website. Schwarzkopf Professional may change the available
              redemption items, or the number of Points which must be redeemed
              for them, at any time.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>Redemption orders cannot be delivered to PO Boxes.</p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Orders are typically processed within one (1) week of redemptions.
              Standard shipping takes 2 - 4 weeks after processing.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              If any redemption item that has been redeemed by a Salon and has
              become discontinued before it is delivered to the Salon,
              Schwarzkopf Professional will return the Point value redeemed for
              the discontinued redemption item back to the Salon account.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              All redemptions are final. After a Salon has submitted a
              redemption request, that request may not be cancelled or revoked,
              and Schwarzkopf Professional will not return any Points redeemed
              by the Salon.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <strong>GENERAL CONDITIONS</strong>
        <ol type="a" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Points cannot be transferred to or from one member to another
              member.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              At any Point Schwarzkopf Professional may issue special promotions
              that alter the rate at which Points are earned or redeemed, such
              as Point multipliers, bonus Points, or other promotional offers on
              certain products, services, days, or portions of any day, that
              change the thresholds at which Points may be redeemed or that
              award additional Points to a particular Salon or group of Salons.
              Schwarzkopf Professional may make such promotional offers to all
              Program participants, or any subset of them, in its sole and
              absolute discretion. Schwarzkopf Professional may communicate
              issuance of these promotional offers via the Website, and/or other
              means available to us. These Terms and Conditions shall apply to
              such offers, along with any additional terms and conditions that
              accompany the offer, unless you are notified otherwise.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Each CLUBSKP Salon membership is linked to one individual email
              address which will remain the primary contact for that CLUBSKP
              Salon member. All communications pertaining to the membership will
              be solely directed to the email provided.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Multiple locations cannot be combined. One location per
              account/Salon membership.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Schwarzkopf Professional is not responsible for any incorrect
              distributor data upload (e.g. a distributor failing to correctly
              upload Schwarzkopf Professional purchases).
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Schwarzkopf Professional reserves the right to invalidate any
              Points from a Salon account if it determines that such Points were
              improperly credited to such Salon account or obtained
              fraudulently. Schwarzkopf Professional reserved the right to
              correct any Points balance (by either adding or removing Points),
              if it determines in its sole and absolute discretion that an error
              has occurred.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Points do not constitute property, do not entitle a participant to
              any vested right or interest, and have no cash value. Points are
              not redeemable for cash, transferable or assignable for any
              reason.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Points are null and void and will be rejected, and removed from
              the Salon’s account, if not obtained in accordance with the letter
              and spirit of these Terms. No Point receipt or redemption will be
              valid if such receipt or redemption is associated with any Point
              deemed void for any reason, including without limitation, if: (a)
              the Point is not verified or recognized as being validly issued by
              Schwarzkopf Professional; (b) the Point is determined to have been
              previously entered and used; (c) the Point was obtained in a
              manner deemed by Schwarzkopf Professional to be fraudulent or
              otherwise invalid; or (d) Point is otherwise void.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              The decisions of Schwarzkopf Professional with respect to all
              aspects of this Program are final and binding on all Salons
              without right of appeal, including, without limitation, any
              decisions regarding the eligibility/disqualification of Salons
              qualifying purchases, and/or Point earning or redemption.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Any abuse or attempted abuse by a Salon of the Program’s
              privileges, or the letter and spirit of these Terms, any failure
              by a Salon to follow these Terms, or any misrepresentation by a
              Salon may subject the Salon to expulsion from the Program,
              including forfeiture of all Points. Without limiting the
              foregoing, any sales which are returned or otherwise cancelled
              will not qualify for the purposes of the Program and any Points
              awarded in respect of such purchases will be void and removed from
              the Salon’s account.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              These Terms constitute the entire agreement between participating
              Salons and Schwarzkopf Professional regarding the Program, Points,
              Rewards and the benefits of the Program, and supersede all
              previous versions.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Any waiver by Schwarzkopf Professional of the strict observance,
              performance or compliance by a Salon with any provision of these
              Terms, either expressly granted or by course of conduct, shall be
              effective only in the specific instance and shall not be deemed to
              be a waiver of any rights or remedies of Schwarzkopf Professional
              as a result of any other failure to observe, perform or comply
              with the provisions of these Terms. No delay or omission by
              Schwarzkopf Professional in exercising any right or remedy
              hereunder shall operate as waiver thereof or of any other right or
              remedy.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              By participating in the Program, you agree to release Schwarzkopf
              Professional, a division of Henkel Corporation, and each of its
              parent companies, subsidiaries, affiliates, and suppliers and any
              other third party that may from time to time participate in the
              administration or operation of the Program, and each of their
              respective officers, directors, agents, representatives,
              employees, successors and assigns (collectively, the{' '}
              <strong>“Releasees”</strong>) from any loss, liability, claim,
              demand, damage or expense asserted by any entity relating in any
              way to the Program, your participation therein and/or the
              use/misuse of any Points or redemption items. TO THE FULLEST
              EXTENT PERMITTED BY APPLICABLE LAW, ALL ASPECTS OF THE PROGRAM ARE
              PROVIDED “AS IS” AND “AS AVAILABLE”, WITHOUT ANY CONDITION,
              REPRESENTATION OR WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED,
              INCLUDING BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
              NON-INFRINGEMENT.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              In the event that any provision in these Terms is determined to be
              invalid, illegal, or unenforceable, such determination shall not
              affect the validity and enforceability of any other remaining
              provisions of these Terms.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              These Terms and any claim or dispute arising out of, relating to
              or in connection with these Terms or the Program contemplated
              hereby, whether in contract, tort or otherwise, shall be governed
              by and construed in accordance with the laws of California
              applicable therein (without regard to conflicts of laws
              principles). You hereby irrevocably and unconditionally consent to
              submit to the exclusive jurisdiction of the state and federal
              courts located in California for any action, suit or proceeding
              arising out of or relating to the transaction contemplated hereby.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Schwarzkopf Professional reserves the right to change, amend,
              modify, suspend or terminate this Program, including any part of
              these Terms, at any time in our sole and absolute discretion. In
              the event the Program or these Terms are changed, amended,
              modified, suspended or terminated, we will post the amended Terms
              or Program on the Website. Your continued participation in the
              Program following such notice will constitute your express consent
              to any change, amendment, modification, suspension or termination
              to these Terms or any other aspect of the Program.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              All enquiries pertaining to the Program must be directed to the
              CLUBSKP administrator at{' '}
              <a href="mailto:clubskp@myskp.com">clubskp@myskp.com</a>
            </p>
          </li>
        </ol>
      </li>
    </ol>
  </div>
);

export default TermsClubskp;



// WEBPACK FOOTER //
// ./src/components/_Site/US/TermsClubskp.js